﻿import { Model } from 'pinia-orm'
import { Bool, Num, Str } from 'pinia-orm/decorators'

export default class BoatClass extends Model {
    static entity = 'classes'

    @Num( 0, { notNullable: true } ) declare id: number
    @Str( '', { notNullable: true } ) declare name: string
    @Str( '', { notNullable: true } ) declare shortcut: string
    @Str( null ) declare flag: string | null
    @Num( null ) declare crewSize: number | null
    @Str( 'A' ) declare scoringSystem: string
    @Bool( false, { notNullable: true } ) declare useBoatNames: boolean
    @Bool( false, { notNullable: true } ) declare useHandicaps: boolean
    @Bool( false, { notNullable: true } ) declare canBeRenamed: boolean
    @Num( 0, { notNullable: true } ) declare ageFrom: number
    @Num( null ) declare ageTo: number | null
    @Str( null ) declare intClassId: string | null

    static piniaOptions = {
        persist: true
    }
}
